// extracted by css-extract-rspack-plugin
export default {"chart":"chart-module__chart--kbife","legend":"chart-module__legend--hlndt","fullscreen":"chart-module__fullscreen--kl2vC","no_data":"chart-module__no_data--mEQg7"};